<template>
  <div>
    <div class="head">
      <el-row>
        <el-col>
          <el-form ref="searchForm" v-model="searchForm" :inline="true" label-suffix="：">
            <el-form-item label="商品名称">
              <el-input v-model="searchForm.PRODUCT_NAME" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="商品编码">
              <el-input v-model="searchForm.PRODUCT_CODE" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="margin-left:20px" @click="handleSearch" :loading="loading">筛选</el-button>
              <el-button type="primary" plain style="margin-left:20px" @click="exportData"
                :loading="loading">导出</el-button>
              <el-button type="primary" plain style="margin-left:20px" @click="exportAllData"
                :loading="loading">导出全部报价</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div style="background:white;border-radius:3px">
      <el-row>
        <el-col>
          <el-table :data="tableData" stripe border>
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
            <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
            <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
            <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
            <el-table-column prop="SUBMIT_PRICE" label="报价"></el-table-column>
            <el-table-column prop="CURRENT_PRICE" label="当前定价"></el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-pagination @current-change='handlePageChange' :current-page.sync="currentPage" :total="totalNum"
          :page-size="pageSize" layout="total, prev, pager, next, jumper" style="float:right">
        </el-pagination>
      </el-row>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: {
        PRODUCT_CODE: '',
        PRODUCT_NAME: '',
      },
      GYS_ID: Number(sessionStorage.getItem('tcId')),
    };
  },
  created() {
    // 这里用来在系统设置中设置页面展示条目，文件在systemSetting的unitManage中，由前端控制条目，存储于localStorage中，key为USER_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.defaultQuery();
  },
  methods: {
    exportAllData() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 13,
        GYS_ID: this.GYS_ID,
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http
        .post(params)
        .then((result) => {
          if (result.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
          } else if (result[0].FILE_PATH !== '') {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          } else {
            this.$message.show({ text: '返回路径异常', type: 'error' });
          }
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 12,
        GYS_ID: this.GYS_ID,
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http
        .post(params)
        .then((result) => {
          if (result.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
          } else if (result[0].FILE_PATH !== '') {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          } else {
            this.$message.show({ text: '返回路径异常', type: 'error' });
          }
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    defaultQuery() {
      const params = {
        SERVICE_ID: '10014',
        OTYPE: 11,
        GYS_ID: this.GYS_ID,
        PAGE_INDEX: this.currentPage - 1,
        PAGE_SIZE: this.pageSize,
      };
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].COMPARE_PRICE_LIST;
          this.totalNum = result[0].TOTAL_COUNT;
        } else {
          this.tableData = [];
          this.totalNum = 0;
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handlePageChange(e) {
      this.defaultQuery();
      this.currentPage = e;
    },
    handleSearch() {
      this.currentPage = 1;
      this.defaultQuery();
    },
  },
};
</script>
<style scoped>
.head {
  background: white;
  border-radius: 3px;
  margin: 20px 0 0px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/priceComparitionResult.vue